module.exports = __webpack_public_path__ + "img/farming_2.09af115c.png";